import store from "@/providers/store"
/**
 * Route guard
 * We will set guards here, for checking if
 * the user has the right access level for
 * entering a specific route
 */
export function ifAuthenticated (to, from, next) {
  // if (to.meta.guard !== undefined &&
  //   store.state.auth.user.permissions &&
  //   store.state.auth.user.permissions.indexOf("view/" + to.meta.guard) < 0) {
  //   next("/")
  //   return
  // }
  if (store.getters["Auth/isAuthenticated"]) {
    next()
    return
  }
  next("/login")
}

export function ifNotAuthenticated (to, from, next) {
  if (!store.getters["Auth/isAuthenticated"]) {
    next()
    return
  }
  next("/")
}
